<template>
  <div>
    <vs-popup :title="$t('DeductionAndIncrease')" :active.sync="showModal">
      <div class="vx-row mb-6">
        <div class="vx-col w-full my-2">
          <label class="vs-select--label my-1">{{ $t("DeductionAndIncreaseType") }}</label>

            <v-select
              class="m-0"
              label="name"
              name="Type"
              :options="deductionAndIncreaseTypes"
              v-model="model.deductionAndIncreaseType"
              :reduce="(x) => x.id"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('Type')">{{
              errors.first("Type")
            }}</span>
          </div>
          <div class="vx-col w-full my-2">
            <label class="vs-select--label my-1">{{ $t("toleranceTypes") }}</label>

            <v-select
              class="m-0"
              label="name"
              name="Telorance"
              :options="toleranceTypes"
              v-model="model.toleranceType"
              :reduce="(x) => x.id"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('Telorance')">{{
              errors.first("Telorance")
            }}</span>
          </div>
          <div class="vx-col w-full my-2">
            <vs-input
              v-model="model.amount"
              name="Amount"
              :label="$t('Amount')"
            />
            <span class="text-danger text-sm" v-show="errors.has('Amount')">{{
              errors.first("Amount")
            }}</span>
          </div>
          <div class="vx-col w-full my-2">
            <vs-textarea
            rows="5"
            class="mt-4"
            name="Description"
            :label="$t('Description')"
            v-model="model.description"
          />
            <span class="text-danger text-sm" v-show="errors.has('Description')">{{
              errors.first("Description")
            }}</span>
          </div>
          <div class="flex justify-end w-full ml-5">
            <vs-button
            type="filled"
            class=" mb-4 mt-4"
            @click.prevent="submitForm"
            :disabled="!model.amount || !model.toleranceType || !model.deductionAndIncreaseType"
            >{{ $t("Save") }}</vs-button
          >
          </div>
  

      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss">
body[dir="rtl"] .vs-popup--content {
  overflow-y: scroll !important;
}
</style>

<script>
  import { mapActions } from "vuex";
  import { Validator } from "vee-validate";
  import vSelect from "vue-select";

  const dict = {
    custom: {
      departmanName: {
        required: "لطفا عنوان دپارتمان را وارد نمایید.",
      },
    },
  };
  Validator.localize("fa", dict);
  
  export default {
    components: {
    "v-select": vSelect

  },
    props: {
      show: { default: false },
 
    },
    data() {
      return {
        model:{
          description:''
        },
        departman: "",
        popupTitle: "",
        disabled: false,
        deductionAndIncreaseTypes: [
          { name: "کسر", id: 1 },
          { name: "اضافه", id: 2 },
        ],
        toleranceTypes: [
          { name: "درصدی", id: 1 },
          { name: "مقداری", id: 2 },
        ],
      };
    },
    computed: {
      showModal: {
        get: function () {
          return this.show;
        },
        set: function () {
          this.$emit("close");
        },
      },
    },
    methods: {
      ...mapActions({
        createAccount: "purchaseOrder/saveDeductionAndIncrease",
        updateAccount: "departman/editDepartman",
      }),
      submitForm() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$emit("finish" , this.model);
                this.model = {};
                this.$validator.reset();
                this.disabled = false;

          } else {
            // form have errors
          }
        });
      },
    },
    watch: {
      show() {
        if (this.show == true) {
          this.disabled = false;
  
          if (this.model.id) this.popupTitle = "DeductionAndIncrease";
          else this.popupTitle = "DeductionAndIncrease";
        }
        this.$validator.reset();
      },
    },
  };
  </script>